import React from 'react';
import '../styles/Projects.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "Smart Fridge",
      description: "An intelligent fridge management system",
      image: "/images/Smart Fridge.png", 
      websiteUrl: "https://shimmering-frangollo-b5711a.netlify.app/",
      githubUrl: "https://github.com/seemanteng/smart-fridge", 
      technologies: ["JavaScript", "HTML/CSS", "Figma"]
    },
    {
      id: 2,
      title: "Play-it-forward",
      description: "Website for impact experience project",
      image: "/images/Playitfwd.png", 
      websiteUrl: "https://playitfrwd.com",
      githubUrl: "https://github.com/seemanteng/play-it-fwd", 
      technologies: ["React", "HTML/CSS", "JavaScript"]
    }
  ];

  return (
    <section className="projects-section">
      <h2 className="section-title">My Projects</h2>
      <div className="projects-container">
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            <div className="project-image-container">
              <a 
                href={project.websiteUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="project-image-link"
              >
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="project-image"
                />
              </a>
              <div className="project-overlay">
                <div className="project-links">
                  <a 
                    href={project.websiteUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="project-link website-link"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"/>
                    </svg>
                    Visit Site
                  </a>
                  <a 
                    href={project.githubUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="project-link github-link"
                  >
                    <img src="/images/github.png" alt="GitHub" className="link-icon" />
                    View Code
                  </a>
                </div>
              </div>
            </div>
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;